<tui-root>
  <a href="#main-content" class="skip-link">Vai al contenuto principale</a>
  <app-header></app-header>
  <main id="main-content">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
  <app-accessibility-widget></app-accessibility-widget>
</tui-root>
